module.exports = __webpack_public_path__ + "static/media/profile_logout.130d9d75.svg";